export function getLabelFromKeyValue(givenKey: string, value: string) {
  if (typeof value !== "string") return false;
  const key = givenKey.includes(".") ? keySplitAndExtract(givenKey) : givenKey;

  let formattedValue = value.replace(/\bYes\b/gi, "").trim();

  formattedValue = formattedValue
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  let keyPartToUse = key.split("_").at(0);
  if (keyPartToUse.toLowerCase() === "primary") {
    keyPartToUse = key.split("_").at(1);
  }

  const formattedKey =
    keyPartToUse.charAt(0).toUpperCase() + keyPartToUse.slice(1);
  const keyParts = formattedKey.split(" ");
  const lastKeyElement = keyParts[keyParts.length - 1];

  const lastWord = formattedValue?.split(" ")?.pop();

  const finalString =
    lastKeyElement.toLowerCase().includes(lastWord.toLowerCase()) ||
    lastWord.toLowerCase().includes(lastKeyElement.toLowerCase())
      ? formattedValue
      : `${formattedValue} ${formattedKey}`;
  return finalString.trim();
}
function keySplitAndExtract(key: string) {
  if (key.includes("color")) return "color";
  const keyParts = key.split(".");
  let lastKeyElement = keyParts[keyParts.length - 1];
  if (lastKeyElement?.toLowerCase?.() === "primary") {
    lastKeyElement = keyParts.at(-2);
  }
  return lastKeyElement;
}
